import { isChrome } from 'helpers/extension';
import { appEnvironment } from 'helpers';

interface OnboardingStep {
  paths: string[];
}

type OnboardingType = 'personal' | 'workExistingOrg' | 'workNewOrg';

type OnboardingFlow = {
  [key in OnboardingType]: OnboardingStep;
};

const createOnboardingFlow = () => {
  if (isChrome && appEnvironment === 'web') {
    return CHROME_STEPS;
  } else if (isChrome) {
    return CHROME_EXTENSION_STEPS;
  } else {
    return OTHER_BROWSERS_STEPS;
  }
};

const CHROME_STEPS: OnboardingFlow = {
  personal: {
    paths: ['connect-apps', 'add-to-chrome', 'finish'],
  },
  workExistingOrg: {
    paths: ['connect-apps', 'add-team', 'add-to-chrome', 'finish'],
  },
  workNewOrg: {
    paths: ['connect-apps', 'setup-organization', 'add-team', 'add-to-chrome', 'finish'],
  },
};

const CHROME_EXTENSION_STEPS: OnboardingFlow = {
  personal: {
    paths: ['connect-apps', 'finish'],
  },
  workExistingOrg: {
    paths: ['connect-apps', 'add-team', 'finish'],
  },
  workNewOrg: {
    paths: ['connect-apps', 'setup-organization', 'add-team', 'finish'],
  },
};

const OTHER_BROWSERS_STEPS: OnboardingFlow = {
  personal: {
    paths: ['connect-apps', 'finish'],
  },
  workExistingOrg: {
    paths: ['connect-apps', 'add-team', 'finish'],
  },
  workNewOrg: {
    paths: ['connect-apps', 'setup-organization', 'add-team', 'finish'],
  },
};

export const ONBOARDING_FLOWS: OnboardingFlow = createOnboardingFlow();
